(() => {
  if (customElements.get('vm-premium-description')) return;
  class PremiumDescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('[data-vm-description-source]');
      if (!source) return;
      const wrapper = source.querySelector('.vi-pdp-v2');
      const guide = document.createElement('div');
      const before = document.createElement('div');
      const specs = document.createElement('div');
      [guide, before, specs].forEach(node => { node.className = 'vi-pdp-v2 vm-premium-fold__body'; });
      if (wrapper) {
        let target = specs;
        [...wrapper.childNodes].forEach(node => {
          if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
            const title = node.textContent.trim().toLowerCase();
            if (title === 'condition guide' || title === 'device condition guide') { target = guide; node.remove(); return; }
            if (title === 'before you order') { target = before; node.remove(); return; }
            target = specs;
          }
          target.append(node);
        });
        wrapper.remove();
        [...source.childNodes].forEach(node => specs.prepend(node));
      } else {
        while (source.firstChild) specs.append(source.firstChild);
      }
      source.remove();
      const fallback = this.querySelector('[data-vm-guide-fallback]');
      if (!guide.textContent.trim() && fallback) {
        while (fallback.firstChild) guide.append(fallback.firstChild);
      }
      fallback?.remove();
      guide.innerHTML = `<div class="vm-premium-guide-table"><table aria-label="Device condition guide"><tbody>
<tr><th scope="row">Pristine</th><td>Looks and feels like brand new. Used very minimally with no visible wear. Functions perfectly in all aspects.</td></tr>
<tr><th scope="row">Mint</th><td>Almost as good as new. No scratches, dents, or defects. May have very faint micro-scratches, barely noticeable even under light.</td></tr>
<tr><th scope="row">Lightly Used</th><td>Light cosmetic wear, with fine surface marks visible on close inspection within 20 cm. No dents or deep marks.</td></tr>
<tr><th scope="row">Well Used</th><td>Noticeable scratches or small dents from previous use. Cosmetic wear does not affect normal operation.</td></tr>
</tbody></table></div><p class="vm-premium-guide-note">Condition ratings describe cosmetic appearance. Battery health and warranty are listed separately.</p>`;
      before.innerHTML = `<div class="vm-premium-before"><ul>
<li>Each device is checked for key functions and factory reset before sale.</li>
<li>Please refer to the selected option for the condition, battery health (where available) and warranty details.</li>
<li>If photos of the actual unit are not available, please WhatsApp us to request them.</li>
<li>Included accessories are listed in the product details.</li>
<li>Need help after purchase? Contact our team for assistance.</li>
</ul></div>`;
      const fold = (title, body, open = false) => {
        if (!body.textContent.trim() && !body.querySelector('img,video,iframe')) return null;
        const details = document.createElement('details');
        details.open = open;
        const summary = document.createElement('summary');
        summary.textContent = title;
        details.append(summary, body);
        this.append(details);
        return details;
      };
      this.specsFold = fold('Specifications', specs);
      fold('Condition Guide', guide, true);
      fold('Before You Order', before, true);
      const productInfo = this.closest('product-info');
      this.facts = productInfo?.querySelector('[data-vm-premium-facts]');
      const sync = () => {
        const current = this.facts?.querySelector('.vm-premium-device:not(.hidden)');
        const complete = current?.dataset.complete === 'true';
        specs.querySelectorAll('.vi-top').forEach(top => { top.hidden = complete; });
        const meaningful = [...specs.children].some(node => !node.hidden && node.tagName !== 'STYLE' && (node.textContent.trim() || node.querySelector('img,video,iframe')));
        if (this.specsFold) this.specsFold.hidden = !meaningful && ![...specs.childNodes].some(node => node.nodeType === 3 && node.textContent.trim());
      };
      sync();
      if (this.facts) {
        this.observer = new MutationObserver(sync);
        this.observer.observe(this.facts, {subtree: true, attributes: true, attributeFilter: ['class']});
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('vm-premium-description', PremiumDescription);
})();
